import { Table, Text } from "@chakra-ui/react";

import { normalizeRenderConfig, sortReportRows } from "../../store/renderConfig";

const ConfiguredReportTable = ({
  columns,
  pinnedColumns = [],
  rows,
  renderConfig,
  renderCell,
  emptyMessage = "No data available for this report",
  presortedRows = false,
}) => {
  const config = normalizeRenderConfig(renderConfig, { columnDefinitions: columns });
  const visibleColumns = [
    ...pinnedColumns,
    ...columns.filter((column) => config.columns.includes(column.id)),
  ];
  const sortedRows = presortedRows
    ? [...(rows || [])]
    : sortReportRows(rows || [], config, { columnDefinitions: columns });

  if (!sortedRows.length) {
    return <Text fontSize="sm">{emptyMessage}</Text>;
  }

  return (
    <Table.Root
      className={`stripedTable reportDataTable reportDataTable--${config.density}`}
      size="sm"
    >
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeader className="reportDataTableCell reportDataTableCell--index">
            <span className="reportDataTableHeaderText">#</span>
          </Table.ColumnHeader>
          {visibleColumns.map((column) => (
            <Table.ColumnHeader
              key={column.id}
              className={`reportDataTableCell reportDataTableCell--${column.id}`}
            >
              <span className="reportDataTableHeaderText">{column.label}</span>
            </Table.ColumnHeader>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {sortedRows.map((row, index) => (
          <Table.Row key={`${row.scopeName || row.name || row.branchName || "row"}-${index}`}>
            <Table.Cell className="reportDataTableCell reportDataTableCell--index">
              {index + 1}
            </Table.Cell>
            {visibleColumns.map((column) => (
              <Table.Cell
                key={column.id}
                className={`reportDataTableCell reportDataTableCell--${column.id}`}
              >
                {renderCell(row, column.id)}
              </Table.Cell>
            ))}
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  );
};

export default ConfiguredReportTable;
